import { createSlice, createAction } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  isSendingMessage: false,
  sendingMessageSuccess: false,
  isSendingComment: false,
  sendingCommentSuccess: false,
  error: null,
}

export const sendExpertVisitRequest = createAction('experts/visitRequest')
export const sendExpertComment = createAsyncActions('experts/comment')
export const sendExpertMessage = createAsyncActions('experts/message')
export const sendProspectVisitRequest = createAction('prospects/visitRequest')
export const sendProspectWaitingList = createAsyncActions(
  'prospects/waitingList'
)

// TODO: Remove this and convert actions to react-query
const expertsSlice = createSlice({
  name: 'experts',
  initialState,
  reducers: {
    clearExpertState() {
      return initialState
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(sendExpertComment.pending, (state) => {
      state.isSendingComment = true
      state.sendingCommentSuccess = false
      state.error = null
    })

    addCase(sendExpertComment.fulfilled, (state) => {
      state.isSendingComment = false
      state.sendingCommentSuccess = true
    })

    addCase(sendExpertComment.rejected, (state, { payload }) => {
      state.isSendingComment = false
      state.error = payload?.error
    })

    addCase(sendExpertMessage.pending, (state) => {
      state.isSendingMessage = true
      state.sendingMessageSuccess = false
      state.error = null
    })

    addCase(sendExpertMessage.fulfilled, (state) => {
      state.isSendingMessage = false
      state.sendingMessageSuccess = true
    })

    addCase(sendExpertMessage.rejected, (state, { payload }) => {
      state.isSendingMessage = false
      state.error = payload?.error
    })

    addCase(sendProspectWaitingList.pending, (state) => {
      state.isSendingRequest = true
      state.sendingRequestSuccess = false
      state.error = null
    })

    addCase(sendProspectWaitingList.fulfilled, (state) => {
      state.isSendingRequest = false
      state.sendingRequestSuccess = true
    })

    addCase(sendProspectWaitingList.rejected, (state, { payload }) => {
      state.isSendingRequest = false
      state.error = payload?.error
    })
  },
})

export const { clearExpertState } = expertsSlice.actions
export const reducer = expertsSlice.reducer
